<div
  class="lg:-mt-12 flex flex-row flex-wrap items-center justify-between gap-2 lg:flex-col lg:items-stretch lg:justify-start lg:gap-1 rounded bg-cp-primary-100 p-3 lg:p-4"
>
  <div class="flex items-center gap-2">
    <div class="relative">
      <img
        src="assets/brands/mlp/support-avatar.png"
        alt="Kundenservice"
        class="size-10"
      />
      <span
        class="absolute -left-0.5 top-[26px] flex size-4 items-center justify-center rounded bg-white text-xs font-bold leading-3 text-cp-primary-100"
        aria-label="KI-generiert"
      >AI</span>
    </div>
    <p class="m-0 text-xs leading-5 text-white">
      Unterstützung zu allen<br />
      Fragen rund um die<br />
      PKW-Versicherung:
    </p>
  </div>
  <a href="tel:+4962223088227" class="text-base font-bold leading-6 text-white no-underline">
    +49 (0) 6222 308 8227
  </a>
</div>
